import { useCallback } from 'react';

import { Button, Image, Modal } from '@pukka/ui-components';
import { useSnapshot } from 'valtio';

import { MarketingModalPersistedState, getUnsafeHTMLContent, onCloseModal as onClose, useImageMarketingModal as useModal } from './state';

interface MarketingModalProps {
  readonly PersistedState?: typeof MarketingModalPersistedState;
  readonly onCloseModal?: typeof onClose;
  readonly useImageMarketingModal?: typeof useModal;
}

function MarketingModal({
  PersistedState = MarketingModalPersistedState,
  onCloseModal = onClose,
  useImageMarketingModal = useModal,
}: MarketingModalProps) {
  const { open } = useSnapshot(PersistedState);
  const { image, cta, height, url, width, caption } = useImageMarketingModal();

  const onClick = useCallback(() => {
    if (url) {
      window.location.href = url;
    }

    onCloseModal();
  }, [url, onCloseModal]);

  return (
    <Modal unwrap open={open} onOpenChange={onCloseModal}>
      <Modal.Content className="bg-neutral-50 md:max-h-[calc(100dvh_-_8rem)] md:w-fit md:min-w-0">
        <Modal.Header className="sticky top-0 px-3 py-2.5">
          <Button variant="nude-blue" size="none" rounding="md" icon="close" onClick={onCloseModal} className="ml-auto block" />
        </Modal.Header>
        <Image
          alt="marketing-modal"
          src={image}
          width={width}
          height={height}
          innerClassName="min-h-60 w-full min-w-80 cursor-pointer"
          onClick={onClick}
        />
        {caption ? <div dangerouslySetInnerHTML={getUnsafeHTMLContent(caption)} className="px-3 py-4 text-center" /> : null}
        {cta ? (
          <Modal.Footer className="sticky bottom-0 p-2 px-3">
            <Button onClick={onClick} className="ml-auto">
              {cta}
            </Button>
          </Modal.Footer>
        ) : null}
      </Modal.Content>
    </Modal>
  );
}

export { MarketingModal };
